import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyMatToggleModule } from "@ngx-formly/material/toggle";
import { UiSchemaModule } from "@vp/data-access/ui-schema";
import { EditCaseCostComponent } from "@vp/formly/edit-case-cost";
import {
  EditServiceCostComponent,
  FormlyEditServiceCostModule
} from "@vp/formly/edit-service-cost";
import { EditUsersListComponent } from "@vp/formly/edit-users-list";
import { FormlyJsonSchemaModule } from "@vp/formly/json-schema";
import { AddRecipientsComponent } from "@vp/tag-manager/ui/add-recipients";
import {
  EditServiceCostPlanComponent,
  EditServiceCostPlanModule
} from "@vp/tag-manager/ui/edit-service-cost-plan";
import { TagEditorComponent } from "./tag-editor.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    EditServiceCostPlanModule,
    FormlyEditServiceCostModule,
    FormlyModule.forChild({
      types: [
        {
          name: "add-recipients",
          component: AddRecipientsComponent
        },
        {
          name: "edit-service-costs-plans",
          component: EditServiceCostPlanComponent
        },
        {
          name: "edit-case-cost",
          component: EditCaseCostComponent
        },
        {
          name: "edit-users-list",
          component: EditUsersListComponent
        },
        {
          name: "edit-service-cost",
          component: EditServiceCostComponent
        }
      ]
    }),
    FormlyJsonSchemaModule,
    FormlyMatToggleModule,
    UiSchemaModule
  ],
  declarations: [TagEditorComponent],
  exports: [TagEditorComponent]
})
export class TagEditorModule {}
